module.exports = __webpack_public_path__ + "static/img/title.3bc77f6c.png";